<div class="chatbot-header d-flex align-items-center justify-content-between gap-2 px-3 py-2 border-bottom border-light border-opacity-10">
  <div class="d-flex align-items-center gap-2 overflow-hidden">
    <span class="chatbot-avatar d-inline-flex align-items-center justify-content-center flex-shrink-0 rounded-3">
      <i class="bi bi-robot"></i>
    </span>

    <div class="overflow-hidden">
      <div class="d-flex align-items-center gap-2">
        <span class="fw-semibold small">AI Campus VSI</span>
        <span class="badge rounded-pill bg-white bg-opacity-10 text-white-50 fw-normal text-xxs-badge">Limited</span>
      </div>
      <div class="text-white-50 text-xs text-truncate">{{ title }}</div>
    </div>
  </div>

  <div class="d-flex align-items-center flex-shrink-0">
    <button
      type="button"
      class="btn btn-sm d-inline-flex align-items-center justify-content-center p-0 border-0 rounded-3 chatbot-icon-btn"
      :class="{ active: is_history_open }"
      @click="$emit('toggle-history')"
      :aria-label="is_history_open ? 'Hide conversation history' : 'Show conversation history'"
      :title="is_history_open ? 'Hide chats' : 'Chats'"
    >
      <i class="bi bi-clock-history"></i>
    </button>

    <button
      type="button"
      class="btn btn-sm d-inline-flex align-items-center justify-content-center p-0 border-0 rounded-3 chatbot-icon-btn"
      @click="$emit('new-conversation')"
      aria-label="Start new conversation"
      title="New conversation"
    >
      <i class="bi bi-pencil-square"></i>
    </button>

    <button
      v-if="show_fullscreen"
      type="button"
      class="btn btn-sm d-inline-flex align-items-center justify-content-center p-0 border-0 rounded-3 chatbot-icon-btn"
      @click="$emit('toggle-fullscreen')"
      :aria-label="is_fullscreen ? 'Exit fullscreen' : 'Open fullscreen'"
      :title="is_fullscreen ? 'Exit fullscreen' : 'Fullscreen'"
    >
      <i :class="is_fullscreen ? 'bi bi-fullscreen-exit' : 'bi bi-arrows-fullscreen'"></i>
    </button>

    <button
      type="button"
      class="btn btn-sm d-inline-flex align-items-center justify-content-center p-0 border-0 rounded-3 chatbot-icon-btn"
      @click="$emit('close')"
      aria-label="Close assistant"
      title="Close"
    >
      <i class="bi bi-x-lg"></i>
    </button>
  </div>
</div>
